export default {
  appMargin ({ screenSize }) {
    switch (screenSize) {
      case 'small':
        return '0px'
      case 'medium':
        return '90px'
      case 'large':
        return '250px'
    }
  }
}
